// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetIsEditable = () => getClaimDefaultState().isEditable;

const setClaimMode = (state, action) => action.isEditable;

export default (state = getClaimDefaultState().isEditable, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_WEAR_PARTS_IS_EDITABLE]: setClaimMode,
        [actions.COPY_CLAIM_WEAR_PARTS]: resetIsEditable,
        [actions.ADD_CLAIM_WEAR_PARTS_ADDITIONAL_REPAIR]: resetIsEditable,
        [actions.RESET_CLAIM_WEAR_PARTS]: resetIsEditable
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/wear-parts/reducers/is-editable.js